import Card from '@mui/material/Card'
import styled from '@mui/material/styles/styled'

export const SettingsCard = styled(Card, {
  name: 'SettingsCard',
  slot: 'Root',
  skipSx: false,
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  justifyContent: 'space-between',
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
}))
